import { UUID_REGEX } from '@constants/routes';
import { USERS_DETAIL_TABS } from '@constants/user';
import { generatePath } from '@helpers/route';

const path = '/settings';

const USER_ID = `:userId(${UUID_REGEX})`;
const ENTITY_ID = `:entityId(${UUID_REGEX})`;
const CREDENTIALS_ID = `:credentialsId(${UUID_REGEX})`;

export const settingsRoutes = {
  ROOT: {
    get rule() {
      return path;
    },
    get make() {
      return () => this.rule;
    },
  },
  API: {
    get rule() {
      return `${path}/api/${ENTITY_ID}?`;
    },
    get make() {
      return (entityId?: string) => generatePath(this.rule, { entityId });
    },
  },
  API_ADD: {
    get rule() {
      return `${path}/api/${ENTITY_ID}/:add`;
    },
    get make() {
      return (entityId: string) => generatePath(this.rule, { entityId, add: 'add' });
    },
  },
  API_EDIT: {
    get rule() {
      return `${path}/api/${ENTITY_ID}/${CREDENTIALS_ID}/:edit`;
    },
    get make() {
      return (entityId: string, credentialsId: string) =>
        generatePath(this.rule, { entityId, credentialsId, edit: 'edit' });
    },
  },
  COMPANY_PROFILE: {
    get rule() {
      return `${path}/company-profile`;
    },
    get make() {
      return () => this.rule;
    },
  },
  DATA_FORMATS: {
    get rule() {
      return `${path}/data-formats/${ENTITY_ID}?`;
    },
    get make() {
      return (entityId?: string) => generatePath(this.rule, { entityId });
    },
  },
  ENTITIES: {
    get rule() {
      return `${path}/organization-structure`;
    },
    get make() {
      return () => this.rule;
    },
  },
  USERS: {
    get rule() {
      return `${path}/users`;
    },
    get make() {
      return () => this.rule;
    },
  },
  USERS_DETAIL: {
    get rule() {
      return `${path}/users/${USER_ID}/:tab(${Object.values(USERS_DETAIL_TABS).join('|')})?`;
    },
    get make() {
      return (
        userId: string,
        tab: typeof USERS_DETAIL_TABS[keyof typeof USERS_DETAIL_TABS] = USERS_DETAIL_TABS.ACCESS
      ) => generatePath(this.rule, { userId, tab });
    },
  },
};
